import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardActions, Typography, Grid, Divider } from '@material-ui/core';
// import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { DiJsBadge, DiHaskell } from 'react-icons/di';
import { FaDocker, FaNodeJs, FaNpm, FaAngular, FaReact, FaPython, FaHtml5, FaCss3Alt, FaBootstrap } from 'react-icons/fa';
import { AiOutlineCode } from 'react-icons/ai';
import uuid from 'uuid/v1';
import { SvgIcon } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  statsItem: {
    display: 'flex',
    alignItems: 'center'
  },
  statsIcon: {
    color: theme.palette.icon,
    marginRight: theme.spacing(1)
  }
}));

const showIcon = (icon) => {
  if (icon && icon === 'DiJsBadge')
    return (<DiJsBadge key={uuid()} style={{ color: '#F1DE4F', width: 25, height: 'auto', borderRadius: 3, }} />)
  if (icon && icon === 'FaNodeJs')
    return (<FaNodeJs key={uuid()} style={{ color: '#54B689', width: 25, height: 'auto', borderRadius: 3, marginLeft: 12 }} />)
  if (icon && icon === 'FaNpm')
    return (<FaNpm key={uuid()} style={{ color: '#BB443E', width: 25, height: 'auto', borderRadius: 3, marginLeft: 12 }} />)
  if (icon && icon === 'AiOutlineCode')
    return (<AiOutlineCode key={uuid()} style={{ color: '#797cea', width: 25, height: 'auto', borderRadius: 3 }} />)
  if (icon && icon === 'FaAngular')
    return (<FaAngular key={uuid()} style={{ color: '#CA3327', width: 25, height: 'auto', borderRadius: 3, marginLeft: 10 }} />)
  if (icon && icon === 'FaReact')
    return (<FaReact key={uuid()} style={{ color: '#62D4FA', width: 25, height: 'auto', borderRadius: 3, marginLeft: 10 }} />)
  if (icon && icon === 'FaPython')
    return (<FaPython key={uuid()} style={{ color: '#356a98', width: 25, height: 'auto', borderRadius: 3 }} />)
  if (icon && icon === 'FaHtml5')
    return (<FaHtml5 key={uuid()} style={{ color: '#EA6228', width: 25, height: 'auto', borderRadius: 3 }} />)
  if (icon && icon === 'FaCss3Alt')
    return (<FaCss3Alt key={uuid()} style={{ color: '#3596D0', width: 25, height: 'auto', borderRadius: 3 }} />)
  if (icon && icon === 'DiHaskell')
    return (<DiHaskell key={uuid()} style={{ color: '#5E5086', width: 30, height: 'auto', borderRadius: 3, marginTop: -4 }} />)
  if (icon && icon === 'FaBootstrap')
    return (<FaBootstrap key={uuid()} style={{ color: '#5E5086', width: 30, height: 'auto', borderRadius: 3 }} />)
  if (icon && icon === 'FaDocker')
    return (<FaDocker key={uuid()} style={{ color: '#2496ED', width: 25, height: 'auto', borderRadius: 3 }} />)
  if (icon && icon === 'MaterialUi')
    return (
      <SvgIcon key={uuid()} style={{ color: '#5E5086', width: 30, height: 'auto', borderRadius: 3 }}>
        {/* <path viewBox="0 0 9 10" d="m0 259.8v-259.8l225 129.9v86.6l-150-86.6v173.2z" fill="#00b0ff"/><path d="m225 129.9 225-129.9v259.8l-150 86.6-75-43.3 150-86.6v-86.6l-150 86.6z" fill="#0081cb"/><path d="m225 303.1v86.6l150 86.6v-86.6z" fill="#00b0ff"/><path d="m375 476.3 225-129.9v-173.2l-75 43.3v86.6l-150 86.6zm150-346.4v-86.6l75-43.3v86.6z" fill="#0081cb"/> */}
      </SvgIcon>)
}

const Experience = props => {
  var { className, experience, ...rest } = props;
  const classes = useStyles()
  return (
    <Card
      {...rest}
    >
      <CardContent>
        {experience.icons.map(icon => showIcon(icon))}
        <Typography
          align="left"
          variant="h6"
          style={{ marginTop: 3, marginBottom: 12 }}
        >
          {experience.title}
        </Typography>
        <Typography
          align="left"
          variant="body1"
          style={{ height: 75 }}
        >
          {experience.description}
        </Typography>
      </CardContent>
      <Divider />
      <CardActions>
        <Grid
          container
          justify="space-between"
        >
          {/* <Grid
            className={classes.statsItem}
            item
          >
            <AccessTimeIcon className={classes.statsIcon} />
            <Typography
              display="inline"
              variant="body2"
            >
              Experience: {experience.experience}
            </Typography>
          </Grid> */}
          <Grid
            className={classes.statsItem}
            item
          >
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

Experience.propTypes = {
  experience: PropTypes.object.isRequired
};

export default Experience;